import { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";


export default function DropdownButton() {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  let userRole = "";

  try {
    const token = localStorage.getItem("token");
    const decoded = token ? jwtDecode(token) : null;
    userRole = String(decoded?.role?.role || decoded?.role || "")
      .trim()
      .toLowerCase()
      .replace(/[\s_-]+/g, "-");
  } catch (err) {
    userRole = "";
  }

  const canManageUsers = userRole === "admin" || userRole === "super-admin";

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside); // ← Fixed here
  }, []);

  const handleOptionClick = (option) => {
    setOpen(false);
    if (option === "user") {
      if (location.pathname === "/users") {
        toast.info("You are already on Add User", {
          style: { backgroundColor: "#051E1C", color: "#fff" },
          autoClose: 1000,
          hideProgressBar: true,
          icon: false, // or replace with custom icon
        });
      } else {
        navigate("/users");
      }
    } else if (option === "logout") {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  };


  const handleLogout = () => {
    localStorage.clear(); // or remove specific token
    navigate("/login");
  };


  return (

    <div className="flex items-center gap-3">
      {/* Profile Menu Button */}
      {canManageUsers && (
        <button
          onClick={() => handleOptionClick("user")}
          className="flex items-center justify-between py-[0.625rem] pl-[1.4375rem] pr-[1.125rem] gap-3 
               bg-[#147A6F] text-white font-medium rounded-[10px]
               w-full max-w-[19.625rem] min-h-[3.4375rem]"
        >
          <img
            src="assets/add-icon.svg"
            alt="Add user"
            className="w-[2.5625rem] h-[2.5625rem]"
          />
          <span className="text-[1.375rem] font-poppins font-semibold">
            Add User
          </span>
        </button>
      )}

      {/* Logout Button (Outside, Right Side) */}
      <button
        onClick={() => handleOptionClick("logout")}
        className="flex items-center justify-center min-h-[3.4375rem] min-w-[3.4375rem]
               bg-[#0A2C29] rounded-full
               hover:bg-[#147A6F] transition"
        title="Logout"
      >
        <img
          src="/assets/logout-white.svg"
          alt="Logout"
          className="w-6 h-6 text-white"
        />
      </button>
    </div>


  );
}